import type { UiLanguage } from '@/utils/uiLocale';
import { manualAdmin } from '@/content/manual/admin';
import { manualBooking } from '@/content/manual/booking';
import { manualFleet } from '@/content/manual/fleet';
import { manualReports } from '@/content/manual/reports';

/** sv, en, de, lt */
export type ManualCopy = readonly [string, string, string, string];

const COPY: Record<string, ManualCopy> = {
  ...manualFleet,
  ...manualBooking,
  ...manualReports,
  ...manualAdmin,
};

const LANG_INDEX: Record<UiLanguage, 0 | 1 | 2 | 3> = {
  sv: 0,
  en: 1,
  de: 2,
  lt: 3,
};

/** Manualtext för en modul. Systemspecifik text vinner över den generella. */
export function moduleManualCopy(
  language: UiLanguage,
  moduleName: string,
  systemName?: string | null
): string | null {
  const row = (systemName ? COPY[`${systemName}:${moduleName}`] : undefined) || COPY[moduleName];
  if (!row) return null;
  const text = (row[LANG_INDEX[language]] || row[0] || '').trim();
  return text || null;
}
